import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  crossTenantSession: false,
  crossTenantSessionHost: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
